import { useAnalytics } from '@contexts/AnalyticsContext'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { Entity } from '@utils/Entities'

interface Props {
  //
}

const AnalyticsMembershipProgram = ({}: Props) => {
  const { updateSelectedMembershipPrograms, selectedMembershipPrograms } =
    useAnalytics()

  // One program at a time and never none: mixing programs mixes billing
  // currencies, and an empty selection is the unscoped query the drill-downs
  // cannot reproduce. The stored value stays an array so the seven consumers
  // keep passing it straight through as `programIds`.
  return (
    <SBAsyncSelect
      placeholder="Select a program"
      style={{ width: '100%', minWidth: 160 }}
      entity={Entity.membershipProgram}
      value={selectedMembershipPrograms?.[0]}
      onChange={(programId: number) =>
        updateSelectedMembershipPrograms([programId])
      }
    />
  )
}

type AnalyticsMembershipProgramType = {
  MembershipProgram: typeof AnalyticsMembershipProgram
}

export { AnalyticsMembershipProgram, type AnalyticsMembershipProgramType }
